import Vue from 'vue'
import Vuex from 'vuex'

// Import all the stores ...
import vehicleStore from './store/backoffice/vehiclesStore'
import clientTypesStore from './store/frontoffice/clientTypesStore'
import licenseTypesStore from './store/frontoffice/licenseTypesStore'
import driversStore from './store/frontoffice/driversStore'
import paymentMethodsStore from './store/frontoffice/paymentMethodsStore'
import walletsStore from './store/frontoffice/walletsStore'
import subscriptionsStore from './store/frontoffice/subscriptionsStore'
import reservationsStore from './store/frontoffice/reservationsStore'
import userStore from './store/userStore'
import notificationsStore from './store/notificationsStore'
import plansStore from './store/backoffice/plansStore'
import configuration from './store/backoffice/configuration'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  // ... and add it to modules
  actions: {
  },

  modules: {
    vehicleStore,
    clientTypesStore,
    licenseTypesStore,
    driversStore,
    paymentMethodsStore,
    walletsStore,
    subscriptionsStore,
    reservationsStore,
    notificationsStore,
    userStore,
    plansStore,
    configuration,
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store.js